module.exports = {
      id: "user-icon-usage",
      viewBox: "0 0 21 21",
      url: __webpack_public_path__ + "svg-sprite-73eb2de96aa4d32e2310be8fc749a2c5.svg#user-icon",
      toString: function () {
        return this.url;
      }
    }